
let brand ="rbs";
const url = window.location.href;
if (url.includes("ulsterbank")){
    brand = "ubn";
}
else if (url.includes("natwest")){
    brand = "nwb";
}
export function eval_inputs_basic_format(selectedOption,selectResOption,selectRegPayment,in_ac,in_sc,in_cardPan,in_rf,surname,postCode,dob,firpay_day,firpay_month,firpay_year,in_freq,amount) {
    var accNumError = document.getElementById('accNum_lblError');
    var sortCodeError = document.getElementById('sortCode_lblError');
    var accCheckError = document.querySelector('input[name ="accountCheck$rblRBs"]:checked');
    var regAccError = document.querySelector('input[name ="resCheck$rblRBs"]:checked');
    var payOptCheck = document.querySelector('input[name ="paymentOptions$rblRBs"]:checked');
    var amount = document.getElementById('amount1_txtStdTextbox').value;
    var addressCheck = true;
    var paymentCheck=true;
    var ret = true;
    var amountCheck =true;
    var check=true;
    var accountCheck = document.getElementById('accountCheck_rblRBs_0').checked;
    if(brand == "ubn"){
        accountCheck = true;
    }
    //validation of acc/card check warning.
    if (!accCheckError) {
        document.getElementById('accountCheck_divRVError_0').style.display = 'block';
        ret = false;
    } 
    if (!payOptCheck) {
        document.getElementById('paymentOptions_pnlRVError').style.display = 'block';
        ret = false;
    }else {
        document.getElementById('paymentOptions_pnlRVError').style.display = 'none';
        //ret = false;
    }
    //validating amount
    if (amount == "") {
        document.getElementById('amount1_txtStdError').textContent = "Amount (£) : is a mandatory field";
        document.getElementById('amount1_txtStdError').style.display = 'block';
        ret = false;
        amountCheck = false;
    } else if (regAccError && payOptCheck && accCheckError && ((in_ac != "" && in_sc != "") || in_cardPan != "")) {
         if (!isValidAmount(amount)) {
            console.log("Check number is integer or not ")
            document.getElementById('amount1_txtStdError').textContent = "Amount (£): invalid data entered";
            document.getElementById('amount1_txtStdError').style.display = 'block';
            ret = false;
            amountCheck = false;
        }else if (Number(amount) == "0") {
            document.getElementById('amount1_txtStdError').textContent = "Amount (£) : Please enter an amount greater than 0";
            document.getElementById('amount1_txtStdError').style.display = 'block';
            ret = false;
            amountCheck = false;
        }else {
            document.getElementById('amount1_txtStdError').style.display = 'none';
        }
    }else {
        document.getElementById('amount1_txtStdError').style.display = 'none';
    }
    //validating Acc Num Details
    if (accountCheck) {
        //validation for Account number
        if(in_ac == "" && regAccError && payOptCheck && amount != "" && amountCheck){
            accNumError.textContent = "Account Number: is a mandatory field";
            accNumError.style.display = 'block';
            ret = false;
            check=false;
        }else if(brand == 'ubn' && in_ac == "" ){
            accNumError.textContent = "Account Number: is a mandatory field";
            accNumError.style.display = 'block';
            ret = false;
            check=false;
        }else if (in_ac !== "" && in_ac.length != 8) {
            accNumError.textContent = "Account Number: must be 8 digits"
            accNumError.style.display = 'block';
            ret = false;
            check=false;
        } else if (in_ac !== "" && !(/^\d+$/).test(in_ac)) {
            accNumError.textContent = "Account Number: enter numbers only";
            accNumError.style.display = 'block';
            ret = false;
            check=false;
        } else if ( brand == 'nwb' && in_ac !== "" && !eval_NWB_AccNum(in_ac)){
            accNumError.textContent = " Account Number: Your account number appears to be incorrect, please re-enter.";
            accNumError.style.display = 'block';
            ret = false;
        }else {
            accNumError.style.display = "none";
        }
        //Validating Sort Code
        if(in_sc == "" && regAccError && payOptCheck && amount != "" && amountCheck){
            sortCodeError.textContent = "Sort Code: is a mandatory field";
            sortCodeError.style.display = 'block';
            ret = false;
            check=false;
        }
        else if(brand == 'ubn' && in_sc == "" ){
            sortCodeError.textContent = "Sort Code: is a mandatory field";
            sortCodeError.style.display = 'block';
            ret = false;
            check=false;
        }else if (in_sc !== "" && in_sc.length != 6) {
            sortCodeError.textContent = "Sortcode: must be 6 digits";
            sortCodeError.style.display = 'block';
            ret = false;
            check=false;
        }else if (in_sc !== "" && !(/^\d+$/).test(in_sc)) {
            sortCodeError.textContent = "SortCode: enter numbers only";
            sortCodeError.style.display = 'block';
            ret = false;
            check=false;
        } else if ((brand == 'nwb' && in_sc !== "" && !eval_NWB_SortCode(in_sc)) || (brand == 'ubn' && in_sc !== "" && !validateSortCode(in_sc)) || (brand == 'rbs' && in_sc !== "" && !validateRBS_Sort_Code(in_sc))) {
            sortCodeError.textContent = "Sort Code: invalid data entered";
            sortCodeError.style.display = 'block';
            ret = false;

        }else if (brand == 'rbs' && in_ac !== "" && in_sc !== "" && !eval_RBS_SC_ACC_vocalink(in_ac,in_sc)) {
            accNumError.textContent = " Your account number and sort code appears to be incorrect, please re-enter.";
            accNumError.style.display = 'block';
            ret = false;
        }else if (brand == 'ubn' && in_ac !== "" && in_sc !== "" && !eval_AccNum_SortCode(in_ac,in_sc) && check) {
            accNumError.textContent = " Your account number and sort code appears to be incorrect, please re-enter."; 
            accNumError.style.display = 'block';
            ret = false;
        }else if (brand != 'ubn' && in_sc !== "" && !TescoSortCodeValidation(in_sc)) {
            sortCodeError.textContent = "Sort Code: Your account number or sort code appears to be incorrect."; 
            sortCodeError.style.display = 'block';
            ret = false;
        }else{
            sortCodeError.style.display = 'none';
        }

        //validating refernce number.
        if (in_rf !== "" && !(/^\d+$/).test(in_rf)) {
            document.getElementById('refNumber_lblError').style.display = 'block';
            ret = false;
        }
        else {
            sessionStorage.setItem('refNumber', in_rf);
            document.getElementById('refNumber_lblError').style.display = 'none';
            //ret = false;
        }
    }

    //validating Card Details
    if (document.getElementById('accountCheck_rblRBs_1').checked && selectedOption=='card' && regAccError && payOptCheck && amount != "" && amountCheck &&brand !='ubn') {
        if(in_cardPan == ""){
            document.getElementById('creditCard1_txtError').textContent = "Card number: is a mandatory field";
            document.getElementById('creditCard1_txtError').style.display  = 'block';
            ret = false;
        }else if (in_cardPan != "" && (!eval_NWB_cardPan(in_cardPan) || in_cardPan.length < 16)) { 
            document.getElementById('creditCard1_txtError').textContent="Card number: Your card number is incorrect, please re-enter.";
            document.getElementById('creditCard1_txtError').style.display = 'block';
            ret = false;
        }else if (in_cardPan != "" && (!TescoCardValidation(in_cardPan))) { 
            document.getElementById('creditCard1_txtError').textContent="Card number: Invalid Card Number.";
            document.getElementById('creditCard1_txtError').style.display = 'block';
            ret = false;
        }else {
            document.getElementById('creditCard1_txtError').style.display = 'none';
        }

    }

    //validation for Please can you confirm this account is registered to a UK address? 
    if (!regAccError && accCheckError) {
        document.getElementById('resCheck_divRVError').style.display = 'block';
        ret = false;
    } else if (selectResOption && selectResOption == 'Yes') {
        document.getElementById('surName_txtStdError').style.display = 'none';
        document.getElementById('postCode_txtStdError').style.display = 'none';
        document.getElementById('dateOfBirth_txtError').style.display = 'none';
        if (surname !== "" && !(/^[A-za-z]+$/).test(surname)) {
            document.getElementById('surName_txtStdError').textContent = "Surname: invalid data entered";
            document.getElementById('surName_txtStdError').style.display = 'block';
            if (postCode == "")
                document.getElementById('postCode_txtStdError').style.display = 'none';
            if (dob == "")
                document.getElementById('dateOfBirth_txtError').style.display = 'none';
            addressCheck = false;
            ret = false;
        }
        if (postCode != "" && !eval_Postcode(postCode)) {
            if (surname == "")
                document.getElementById('surName_txtStdError').style.display = 'none';
            if (dob == "")
                document.getElementById('dateOfBirth_txtError').style.display = 'none';
            addressCheck = false;
            ret = false;
        }
        if (dob !== "" && !(/^\d{4}-\d{2}-\d{2}$/).test(dob)) {
            document.getElementById('dateOfBirth_txtError').textContent = "Date of Birth (YYYY-MM-DD): Please enter a valid date in the format YYYY-MM-DD.";
            document.getElementById('dateOfBirth_txtError').style.display = 'block';
            if (surname == "")
                document.getElementById('surName_txtStdError').style.display = 'none';
            if (postCode == "")
                document.getElementById('postCode_txtStdError').style.display = 'none';
            addressCheck = false;
            ret = false;
        }
        else if (dob !== "" && !validateDOB(dob)) {
            addressCheck = false;
            ret = false;
        }
        if ((accCheckError) && payOptCheck && amount != "") {
            if ((surname == "" && postCode == "" && dob == "")) {
                if (surname == "") {
                    document.getElementById('surName_txtStdError').textContent = "Surname: is a mandatory field";
                    document.getElementById('surName_txtStdError').style.display = 'block';
                    ret = false;
                }
                if (postCode == "") {
                    document.getElementById('postCode_txtStdError').textContent = "PostCode: is a mandatory field";
                    document.getElementById('postCode_txtStdError').style.display = 'block';
                    ret = false;
                }
                if (dob == "") {
                    document.getElementById('dateOfBirth_txtError').textContent = "Date of Birth (YYYY-MM-DD): is a mandatory field";
                    document.getElementById('dateOfBirth_txtError').style.display = 'block';
                    ret = false;
                }
            } else if ((surname == "" || postCode == "" || dob == "") && addressCheck) {
                if (surname != "" && postCode == "" && dob == "") {
                    document.getElementById('postCode_txtStdError').textContent = "PostCode: is a mandatory field";
                    document.getElementById('postCode_txtStdError').style.display = 'block';
                    document.getElementById('dateOfBirth_txtError').textContent = "Date of Birth (YYYY-MM-DD): is a mandatory field";
                    document.getElementById('dateOfBirth_txtError').style.display = 'block';
                    document.getElementById('surName_txtStdError').style.display = 'none';
                    ret = false;
                }
                if (surname == "" && postCode != "" && dob == "") {
                    document.getElementById('surName_txtStdError').textContent = "Surname: is a mandatory field";
                    document.getElementById('surName_txtStdError').style.display = 'block';
                    document.getElementById('dateOfBirth_txtError').textContent = "Date of Birth (YYYY-MM-DD): is a mandatory field";
                    document.getElementById('dateOfBirth_txtError').style.display = 'block';
                    document.getElementById('postCode_txtStdError').style.display = 'none';
                    ret = false
                }
                if (surname == "" && postCode == "" && dob != "") {
                    document.getElementById('surName_txtStdError').textContent = "Surname: is a mandatory field";
                    document.getElementById('surName_txtStdError').style.display = 'block';
                    document.getElementById('postCode_txtStdError').textContent = "PostCode: is a mandatory field";
                    document.getElementById('postCode_txtStdError').style.display = 'block';
                    document.getElementById('dateOfBirth_txtError').style.display = 'none';
                    ret = false
                }
                if (surname != "" && postCode != "" && dob == "") {
                    document.getElementById('postCode_txtStdError').style.display = 'none';
                    document.getElementById('dateOfBirth_txtError').textContent = "Date of Birth (YYYY-MM-DD): is a mandatory field";
                    document.getElementById('dateOfBirth_txtError').style.display = 'block';
                    document.getElementById('surName_txtStdError').style.display = 'none';
                    ret = false;
                }
                if (surname == "" && postCode != "" && dob != "") {
                    document.getElementById('surName_txtStdError').textContent = "Surname: is a mandatory field";
                    document.getElementById('surName_txtStdError').style.display = 'block';
                    document.getElementById('dateOfBirth_txtError').style.display = 'none';
                    document.getElementById('postCode_txtStdError').style.display = 'none';
                    ret = false
                }
                if (surname != "" && postCode == "" && dob != "") {
                    document.getElementById('surName_txtStdError').textContent = 'none'
                    document.getElementById('postCode_txtStdError').textContent = "PostCode: is a mandatory field";
                    document.getElementById('postCode_txtStdError').style.display = 'block';
                    document.getElementById('dateOfBirth_txtError').style.display = 'none';
                    ret = false
                }
            }

        } else {
            document.getElementById('surName_txtStdError').style.display = 'none';
            document.getElementById('postCode_txtStdError').style.display = 'none';
            document.getElementById('dateOfBirth_txtError').style.display = 'none';
        } 
    }else if (regAccError && accCheckError) {
        document.getElementById('resCheck_divRVError').style.display = 'none';
    } 

    //validation for Please choose from one of the following payment options *
    if (payOptCheck && (selectRegPayment && selectRegPayment == 'regular')) {
        document.getElementById('paymentOptions_DateError_00').style.display = 'none';
        document.getElementById('frequency_lblError').style.display = 'none';
        if ((firpay_day !== "" && firpay_month == "" && firpay_year == "") || (firpay_day == "" && firpay_month !== "" && firpay_year == "")
                || (firpay_day == "" && firpay_month == "" && firpay_year !== "") || (firpay_day !== "" && firpay_month !== "" && firpay_year == "")
                || (firpay_day == "" && firpay_month !== "" && firpay_year !== "") || (firpay_day != "" && firpay_month == "" && firpay_year !== "")) {
                document.getElementById('paymentOptions_DateError_00').textContent = "First payment date: please complete all fields"
                document.getElementById('paymentOptions_DateError_00').style.display = 'block'
                document.getElementById('frequency_lblError').style.display = 'none';
                ret = false;
                paymentCheck=false;

            } else if (firpay_day !== "" && firpay_month !== "" && firpay_year !== "") {
                const current = new Date();
                let day = current.getDate();
                let month = current.getMonth() + 1;
                let year = current.getFullYear();

                if (firpay_year < year) {
                    document.getElementById('paymentOptions_DateError_00').textContent = "First payment date: The date cannot be in the past"
                    document.getElementById('paymentOptions_DateError_00').style.display = 'block'
                    ret = false;
                    paymentCheck=false;
                }
                if (firpay_year == year) {
                    if (firpay_month < month) {
                        document.getElementById('paymentOptions_DateError_00').textContent = "First payment date: The date cannot be in the past"
                        document.getElementById('paymentOptions_DateError_00').style.display = 'block'
                        ret = false;
                        paymentCheck=false;
                    }
                    if (firpay_month == month) {
                        if (firpay_day < day) {
                            document.getElementById('paymentOptions_DateError_00').textContent = "First payment date: The date cannot be in the past"
                            document.getElementById('paymentOptions_DateError_00').style.display = 'block'
                            ret = false;
                            paymentCheck=false;

                        }
                    }
                }
            }
        if (accCheckError && regAccError && payOptCheck && amount != "" && amountCheck && paymentCheck) {
            if (in_freq == "" && firpay_day == "" && firpay_month == "" && firpay_year == "") {
                if (firpay_day == "" && firpay_month == "" && firpay_year == "") {
                    document.getElementById('paymentOptions_DateError_00').textContent = "First payment date: is a mandatory field"
                    document.getElementById('paymentOptions_DateError_00').style.display = 'block'
                    ret = false;
                }

                if (in_freq == "") {
                    document.getElementById('frequency_lblError').textContent = "Frequency: is a mandatory field";
                    document.getElementById('frequency_lblError').style.display = 'block';
                    ret = false;
                }

            } else if (firpay_day !== "" && firpay_month !== "" && firpay_year !== "" && in_freq == "") {
                document.getElementById('paymentOptions_DateError_00').style.display = 'none';
                document.getElementById('frequency_lblError').textContent = "Frequency: is a mandatory field";
                document.getElementById('frequency_lblError').style.display = 'block';
                ret = false;
            } else if (firpay_day == "" && firpay_month == "" && firpay_year == "" && in_freq != "") {
                document.getElementById('paymentOptions_DateError_00').textContent = "First payment date: is a mandatory field"
                document.getElementById('paymentOptions_DateError_00').style.display = 'block';
                document.getElementById('frequency_lblError').style.display = 'none';
                ret = false;
            }
        } 
    }


    if (!accCheckError) {
        ret = false;
    } else if (ret == false || selectedOption == 'account' && (in_ac == "" || in_sc == "") || (regAccError== null || (regAccError && selectResOption == 'Yes' && (surname == "" || postCode == "" || dob == "")) )||
        (payOptCheck== null || (payOptCheck && selectRegPayment == 'regular' && (( in_freq == "") || (firpay_day == "")|| (firpay_month == "")|| (firpay_year == "")))) || amount == "") {
        document.getElementById('accountCheck_divRVError_0').style.display = 'none';
        document.getElementById('accountCheck_divRVError_1').style.display = 'block';
        ret = false;
    }else{
        document.getElementById('accountCheck_divRVError_1').style.display = 'none';
    }

    return ret;
    
} // END function eval_inputs_basic_format()

function isValidAmount(amount){
    var regex = /^[0-9]+(\.[0-9]{2})?$/;
    if(!regex.test(amount)){
        return false;
    }
    return true;
    }
export function eval_NWB_SortCode(in_sc) {

    const nwb_lower_range = "10000, 500000, 510000, 520000, 530000, 540000, 550000, 560000, 600000";
    const nwb_upper_range = "19999, 509999, 519999, 529999, 539999, 549999, 558199, 560099, 608099";
    var arrLower = nwb_lower_range.split(",");
    var arrUpper = nwb_upper_range.split(",");
    let blnRet = false;

    for (let intCtr = 0; intCtr < arrLower.length; intCtr++) {
        if ((in_sc >= parseInt(arrLower[intCtr], 10)) && (in_sc <= parseInt(arrUpper[intCtr], 10))) {
            //correct Sortcode
            blnRet = true;
            break;
        }

    }
    return blnRet;

}

export function eval_NWB_AccNum(in_ac) {
    //Check for valid NWB Account Num (mod 11)
    let blnRet = true;
    var intMultiplier = 1;
    var lngAddUp = 0;

    for (let intCtr = 7; intCtr >= 0; intCtr--) {
        let lngChar = 0;
        lngChar = parseInt(in_ac.substring(intCtr, intCtr + 1), 10) * intMultiplier;
        lngAddUp += lngChar;
        intMultiplier += 1;
    }

    if (lngAddUp % 11 !== 0) {
        blnRet = false;
    }
    return blnRet;
}

//CardPan Validation
export function eval_NWB_cardPan(in_cardpan) {
    var cardBinRanges;
    if (brand == 'nwb') {
         cardBinRanges = "402193,404783,425719,426393,427300,445958,448527,453929,453937,454420,454438,471505,529916,543468,543556,543557,543699,545140,545460,546811,547367,552213,556951,539480,523642,512687,528684";
    } else if (brand == 'rbs') {
        // Session["RBSBinRange"] = "400880,425749,448405,454305,456849,462719,491834,520326,542615,543480,543482,543484,547356,549023,552085,556950,552068,539504";
        // Session["TPFBinRange"] = "520641,401343,402939,518645,552188,465590,518652,401344,430567,430568,521804";
        // Session["MINTinRange"] = "445974,491007,542851,546016,546019,646019";
         cardBinRanges = "400880,425749,448405,454305,456849,462719,491834,520326,542615,543480,543482,543484,547356,549023,552085,556950,552068,539504,520641,401343,402939,518645,552188,465590,518652,401344,430567,430568,521804,445974,491007,542851,546016,546019,646019";
    }
    const cardBinRangesSplit = cardBinRanges.split(',');
    var cardBin = in_cardpan.substring(0, 6);
    let flag = false;

    for (var i = 0; i < cardBinRangesSplit.length; i++) {
        if (cardBin == cardBinRangesSplit[i]) {
            flag = true;
        }
    }


    if (flag == true) {
        //second mod check on card number
        var weighting = "2121212121212121";
        var strTemp = "";
        var addup = 0;

        strTemp = in_cardpan;

        for (let i = 16; i > 0; i--) {
            let x = 0;
            x = parseInt(strTemp.substring(i - 1, i)) * parseInt(weighting.substring(i - 1, i));
    
            // if x is more than 9, add the separate digits to each other
            x = Math.floor(x / 10) + (x % 10);
            addup = x + addup;
        }

        if (addup % 10 !==0) {
            flag = false;
        }
    }
    return flag;
}



export function eval_Postcode(strData) {
    //Check for valid postcode, including Girobank special (GIR001) and BFPO 

    let blnRet = true;
    var intCount = 0;
    var intPosition = 0;
    for (let intCtr = 0; intCtr < strData.length; intCtr++)
    {
        if ((strData.charAt(intCtr) == " ") || (strData.charAt(intCtr) == null)) {
            intCount = intCount + 1;

            if (intCtr == 2 || intCtr == 3 || intCtr == 4) {
                intPosition = intPosition + 1;
            }
        }
    }


    if (intCount == 0) {
        document.getElementById('postCode_txtStdError').textContent = "Postal Code: Please enter a valid UK Postal Code with a space between the first and last group of characters.";
        document.getElementById('postCode_txtStdError').style.display = 'block';
        return false;
    }
    if (intPosition == 0) {
        document.getElementById('postCode_txtStdError').textContent = "Postal Code: Please enter a valid UK Postal Code in the correct format";
        document.getElementById('postCode_txtStdError').style.display = 'block';
        return false;
    }

            
    //Convert input to upper case
    strData = strData.toUpperCase();
    //Remove any spaces
    var strTemp = "";
    for (let intCtr = 0; intCtr < strData.length; intCtr++) {
        if (strData.charAt(intCtr) !== " ") {
            strTemp += strData.charAt(intCtr);
        }
    }
    strData = strTemp;
    //Patterns to match against
    var arrPatterns = new Array(4);
    // Standard UK postcode
    arrPatterns[0] = "^(?:[A-PR-UWYZ](?:\\d|\\d{2}|[A-HK-Y]\\d|[A-HK-Y]\\d\\d|\\d[A-HJKSTUW]|[A-HK-Y]\\d[ABEHMNPRV-Y]) ?\\d[ABD-HJLNP-UW-Z]{2})$"; // eslint-disable-line

    // Exception for the special postcode GIR 0AA
    arrPatterns[1] = "^(GIR)(0AA)$"; // eslint-disable-line

    // Standard BFPO numbers
    arrPatterns[2] = "^(BFPO)([0-9]{1,4})$"; // eslint-disable-line

    // c/o BFPO numbers
    arrPatterns[3] = "^(BFPO)(C\/O[0-9]{1,3})$"; // eslint-disable-line


    blnRet = false; //Set RC to false so we can check for valid match
    var objPattern = null;

    for (var i = 0; i < arrPatterns.length; i++) {
        var strPattern = arrPatterns[i];
        objPattern = new RegExp(strPattern);
        if (objPattern != null) {
            if (objPattern.test(strData)) {
                blnRet = true;
                break;
            }
        }
    }
    if (!blnRet) {
        document.getElementById('postCode_txtStdError').textContent = "Postal Code: invalid data entered";
        document.getElementById('postCode_txtStdError').style.display = 'block';
    }
    return blnRet;
}

 const obj_rbs_vocalink_data = {
    "15": "150000 158000 MOD11    4    3    0    0    0    0    2    7    6    5    4    3    2    1", // RBS
    "16": "160000 161027 MOD11    0    0    6    5    4    3    2    7    6    5    4    3    2    1", // RBS
    "83": "830000 835700 MOD11    0    0    4    3    2    7    2    7    6    5    4    3    2    1"  // RBS
};

function get_vocalink_multiplier_data(prefix) {
    var vocalink_data = "";
    vocalink_data = obj_rbs_vocalink_data[prefix]

    if (vocalink_data) {
        var voca_vals = vocalink_data.split(/\s+/);
        var mod_val = voca_vals[2].substr(3, 2);
        var mult_val = voca_vals.slice(3).join('');

        var ret_mod_mult = new Object();
        ret_mod_mult = [mod_val, mult_val];
        return ret_mod_mult;
    }
    return null;
   
}

function validateRBS_Sort_Code(sortCode){
    var prefix = sortCode.substr(0, 2);
    var vocalink_data = obj_rbs_vocalink_data[prefix];
    
    if(vocalink_data == "" || vocalink_data == undefined){
        return false;
    }
    return true;
}

//RBS ACC Sort Code validation
function eval_RBS_SC_ACC_vocalink(in_ac, in_sc) {
    var mod_val;
    var mult_str;
    var blnRet = false;
    // Grab 1st 2 digits of Sortcode
    var in_sc_2_char = in_sc.substr(0, 2);
    // Select correct mult_str
    //var mult_str     = obj_mult_rbs_sc_acc[in_sc_2_char];
    var mod_mult = get_vocalink_multiplier_data(in_sc_2_char);
    if (mod_mult) {
        mod_val = mod_mult[0];
        mult_str = mod_mult[1];

        var sc_ac = in_sc + in_ac;
        var temp = "";
        var addup = 0;
        for (var i = 0; i < mult_str.length; i++) {
            temp = temp + mult_str.substr(i, 1) + ',';
            addup += mult_str.substr(i, 1) * sc_ac.substr(i, 1);
        }
        var addup_mod_val = addup % mod_val;


        if (addup_mod_val == 0) {
            blnRet = true;
        }
    } else {
        console.error('Nodata found');
    }

    return blnRet;
}

//Tesco validation for SortCode 

function TescoSortCodeValidation(sortCode){
var isTescoSortcode='830333,830377';
var blnValidateOK7 = true;
const isTescoSortCodeSplit = isTescoSortcode.split(',');
for (var i = 0; i < isTescoSortCodeSplit.length; i++) {
    if (sortCode==isTescoSortCodeSplit[i])
        {
	    blnValidateOK7 = false;
        ShowTescoMessage();
        }
}
return blnValidateOK7;
}

//Tesco Card Validation
function TescoCardValidation(card) {
    var blnValidateOK7 = true;
    let cardBeginRange = "401343,401344,402939,430567,430568,465590,518645,518652,520641,521804,552188";
    let cardBegin = '';
    cardBegin = card.substring(0, 6);
    const tempRanges = cardBeginRange.split(',');
    for (let tempRange of tempRanges) {
        if (cardBegin.trim() === tempRange.trim()) {
            blnValidateOK7 = false;
            ShowTescoMessage();
        }
    }
    return blnValidateOK7;
}



//Ulster ACC Sort Code validation
function eval_AccNum_SortCode(in_ac, in_sc) {
    var weighting2 = "21212121212121";
    var weighting1 = "00000076543210";
    var strTemp = "";
    let addup = 0;
    var blnValidateOK = true;
    var blnValidateOK1 = true;

    strTemp = in_sc + in_ac;
    //where account number is identified to be a mortgage one, skip full account val by setting flag blnValidateOK
    if (in_ac.substring(0, 1) == "1") {
        blnValidateOK1 = false;

    }

    if (blnValidateOK1) {
        for (let i = 14; i > 0; i--) {
            let x = 0;
            console.log("Substring sc ac" + parseInt(strTemp.substring(i - 1, i)));
            console.log("Substringweighting1" + parseInt(weighting1.substring(i - 1, i)));
            x = parseInt(strTemp.substring(i - 1, i)) * parseInt(weighting1.substring(i - 1, i));
            console.log("addup" + addup);
            addup = x + addup;
        }

        if (addup % 11 != 0) {
            blnValidateOK = false;
        }
        else {
            addup = 0;
            for (let i = 14; i > 0; i--) {
                let x = 0;

                x = parseInt(strTemp.substring(i - 1, i)) * parseInt(weighting2.substring(i - 1, i));

                if (x >= 10) {
                    x = x - 9;
                }

                addup = x + addup;
            }

            if (addup % 10 != 0) {
                blnValidateOK = false;
            }

        }
    }
    return blnValidateOK;
}


function fCheckDateValid(strDate) {
    const dteInvalid = new Date(0);
    let dteResult = new Date(strDate);
    if (isNaN(dteResult.getTime())) {
        return false;
    }
    else {
        return true;
    }
}

function validateSortCode(strData, strLower, strUpper) {

    var strLower = "980000";
    var  strUpper = "989999";
    let blnRet = false;
    let lngSC = parseInt(strData);
  
    let arrLower = strLower.split(',');
    let arrUpper = strUpper.split(',');
  
    for (let intCtr = 0; intCtr < arrLower.length; intCtr++) {
      if (lngSC >= parseInt(arrLower[intCtr]) && lngSC <= parseInt(arrUpper[intCtr])) {
        // Correct Sortcode
        blnRet = true;
        break;
      }
    }
  
    return blnRet;
  }
  
function validateDOB(strData) {
    let blnRet = true;
    var strDateFormat = new Array(3);
    strDateFormat = strData.split('-');
    var strDay;
    var strMonth;
    var strYear;
    var dTTest = new Date;
    var strTestDate;

    if (strData.length > 0) {

        //Date Of Birth Validation                 

        if (strDateFormat.length < 3) {
            document.getElementById('dateOfBirth_txtError').textContent = "Date of Birth (YYYY-MM-DD): Please enter a valid date in the format YYYY-MM-DD.";
            document.getElementById('dateOfBirth_txtError').style.display = 'block';
            blnRet = false;
        }
        else {
            strYear = strDateFormat[0];
            strMonth = strDateFormat[1];
            strDay = strDateFormat[2];



            if ((strDay.length != 2) || (strMonth.length != 2) || (strYear.length != 4)) {
                document.getElementById('dateOfBirth_txtError').textContent = "Date of Birth (YYYY-MM-DD): Please enter a valid date in the format YYYY-MM-DD.";
                document.getElementById('dateOfBirth_txtError').style.display = 'block';
                blnRet = false;
            }

            else {
                if ((parseInt(strDay) < 1) || (parseInt(strDay) > 31) || (parseInt(strMonth) < 1) || (parseInt(strMonth) > 12)) {
                    document.getElementById('dateOfBirth_txtError').textContent = "Date of Birth (YYYY-MM-DD): Please enter a correct date in the format YYYY-MM-DD.";
                    document.getElementById('dateOfBirth_txtError').style.display = 'block';
                    blnRet = false;
                }

                else {
                    // Convert the date string to a Date object
                    let dTTest = new Date(strYear, parseInt(strMonth) - 1, strDay);

                    // Check if the date components match the input
                    if ((parseInt(dTTest.getFullYear()) == parseInt(strYear)) && (parseInt(dTTest.getMonth() + 1) == parseInt(strMonth)) && (parseInt(dTTest.getDate()) == parseInt(strDay))) {
                        
                        strTestDate=strData;
                        // Validate if the date is a future date
                        if (validateForFutureDate(strTestDate)) {
                            document.getElementById('dateOfBirth_txtError').textContent = "Date of Birth (YYYY-MM-DD): The date cannot be a future date, please re-enter.";
                            document.getElementById('dateOfBirth_txtError').style.display = 'block';
                            blnRet = false;
                        }
                    }

                    else {
                        document.getElementById('dateOfBirth_txtError').textContent = "Date of Birth (YYYY-MM-DD): Please enter a correct date in the format YYYY-MM-DD.";
                        document.getElementById('dateOfBirth_txtError').style.display = 'block';
                        blnRet = false;
                    }
                }
            }
        }
    }
    return blnRet;

}

    


//Validating Future date (included for Date of Birth Validation)
function validateForFutureDate(strDate) {
    // Split the date string into year, month, and day
    const strDateFormat = strDate.split('-');
    const currentDate = new Date();
    const testYear = parseInt(strDateFormat[0]);
    const testMonth = parseInt(strDateFormat[1]);
    const testDay = parseInt(strDateFormat[2]);

    // Check if the year is greater than the current year
    if (testYear > currentDate.getFullYear()) {
        return true;
    } else if (testYear < currentDate.getFullYear()) {
        return false;
    } else {
        // Check if the month is greater than the current month
        if (testMonth > currentDate.getMonth() + 1) {
            return true;
        } else if (testMonth < currentDate.getMonth() + 1) {
            return false;
        } else {
            // Check if the day is greater than the current day
            if (testDay > currentDate.getDate()) {
                return true;
            } else {
                return false;
            }
        }
    }
}

function ShowTescoMessage()
    {
        var tempObj = null;
        if (document.getElementById("accountCheck_rblRBs_0"))
        {
            tempObj = document.getElementById("accountCheck_rblRBs_0");
            tempObj.disabled = true;
        }
        if (document.getElementById("accountCheck_rblRBs_1"))
        {
            tempObj = document.getElementById("accountCheck_rblRBs_1");
            tempObj.disabled = true;
        }
        
        if (document.getElementById("paymentOptions_rblRBs_0"))
        {
            tempObj = document.getElementById("paymentOptions_rblRBs_0");
            tempObj.disabled = true;
        }
        
        if (document.getElementById("paymentOptions_rblRBs_1"))
        {
            tempObj = document.getElementById("paymentOptions_rblRBs_1");
            tempObj.disabled = true;
        }
        if(document.getElementById("S_CANCEL"))
        {
            document.getElementById("S_CANCEL").disabled = true;
        }
        if (document.getElementById("resCheck_rblRBs_0"))
	{
	    tempObj = document.getElementById("resCheck_rblRBs_0");
	    tempObj.disabled = true;
	}
    if (document.getElementById("resCheck_rblRBs_1")) {
        tempObj = document.getElementById("resCheck_rblRBs_1");
        tempObj.disabled = true;
    }
        var width = 500;
        var height = 500;
        var left = parseInt((window.screen.availWidth/2) - (width/2));
        var top = parseInt((window.screen.availHeight/2) - (height/2));

        var windowFeatures = 'width= ${width},height=${height},status=no,resizable=no,toolbar=no,location=no,scrollbars=no,titlebar=no,left=${left},top= ${top} ,screenX= ${left},screenY=${top}';
        //window.open("RBS_Tesco.htm",null,"height=100,width=500,status=yes,toolbar=no,menubar=no,location=no,scrollbars=no,resizable=no,titlebar=no");
        //window.open("RBS_Tesco.htm", null, windowFeatures);
       if(brand=='nwb') {
            window.open("/tesconwb",'_blank', windowFeatures);
        }
        else if(brand =='rbs'){
            window.open("/tescorbs", '_blank', windowFeatures);
        }
    }



export function formatCurrentDate() {
    const now = new Date();

    console.log("Current Date" + now);
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const formattedDate = day + "/" + month + "/" + year  + " " + hours + ":" + minutes + ":" + seconds;
    return formattedDate;
}


export function populate_WP_form_value(AccCardOption, resCheck,paymentOption,amount,in_ac,in_sc,in_cardPan,in_rf,surname,postCode,dob,firpay_day,firpay_month,firpay_year,in_freq) {
    var cartId = document.getElementById('cartId');
    var cc1 = document.getElementById('cc1');
    var ac = document.getElementById('ac');
    var sc = document.getElementById('sc');
    var radio = document.getElementById('radio');
    var radio2 = document.getElementById('radio2');
    var reference = document.getElementById('reference');

    var shopAccNum = document.getElementById('shopperAdditionalAccountNumber');
    var shopAddLastNm = document.getElementById('shopperAdditionalLastName');
    var shopPostCode = document.getElementById('shopperAdditionalPostalCode');

    var shopBirDate = document.getElementById('shopperAdditionalBirthDate');
    var residentCheck = document.getElementById('residentCheck');


    var creditCardConf = document.getElementById('creditCardConf');
    var accNumConf = document.getElementById('accNumConf');
    var sortCodeConf = document.getElementById('sortCodeConf');
    var priCardNumConf = document.getElementById('priCardNumConf');
    var surNameConf = document.getElementById('surNameConf');
    var postCodeConf = document.getElementById('postCodeConf');
    var dateOfBirthConf = document.getElementById('dateOfBirthConf');


    var singleFields = document.getElementById('singleFields');
    var amountConf = document.getElementById('amountConf');
    var accSingleInstId = document.getElementById('accSingleInstId');
    var cardSingleInstId = document.getElementById('cardSingleInstId');
    var amount1 = document.getElementById('amount');
    var regularFields = document.getElementById('regularFields');
    var amount1Lbl = document.getElementById('amount1Lbl');
    var intervalUnitLbl = document.getElementById('intervalUnitLbl');
    var startDateLbl = document.getElementById('startDateLbl');
    var accRegularInstId = document.getElementById('accRegularInstId');
    var cardRegularInstId = document.getElementById('cardRegularInstId');
    var startDate = document.getElementById('startDate');
    var intervalUnit = document.getElementById('intervalUnit');
    var normalAmount = document.getElementById('normalAmount');
    var strCreditCardNo="";
    var accountCheck  = AccCardOption;
    const now = new Date();

    //build reference for WorldPay (cartId)
    var space =" ";
    cartId.value = in_rf + space + in_sc + space +in_cardPan+ space + in_ac + space + formatCurrentDate();//+// formatted_time() ;// eslint-disable-line


    if (AccCardOption == "card") {
        cc1.value = in_cardPan;

    }
    else {
        ac.value = in_ac;
        sc.value = in_sc;
    }

    radio.value = paymentOption;
    reference.value = in_rf;

    if (in_cardPan != "") {
        strCreditCardNo = in_cardPan.slice(0, 6) + in_cardPan.slice(-4); // eslint-disable-line

    }

    if ((AccCardOption == "account") && (resCheck == "Yes")) {
        shopAccNum.value = in_ac;
    }
    else if ((AccCardOption == "card") && (resCheck == "Yes")) {
        shopAccNum.value = strCreditCardNo;
    }

    shopAddLastNm.value = surname;
    shopBirDate.value = dob;
    shopPostCode.value = postCode;
    residentCheck.value = resCheck;
    if(brand !='ubn')
    radio2.value = AccCardOption;

    //only populate the hidden field that is needed for the summary
    if (in_ac != "" && AccCardOption == "account" && (brand != 'ubn')) {
        accNumConf.textContent = "Destination account number - " + " " + in_ac ;// eslint-disable-line
    }else if (in_ac != "" && AccCardOption == "account" && (brand == 'ubn')) {
        accNumConf.textContent = " Account number - " + in_ac ;// eslint-disable-line
    }else{
        accNumConf.textContent = '';
    }

    if (in_sc != "" && AccCardOption == "account" && (brand != 'ubn')) {
        sortCodeConf.textContent = "Destination sort code - " + " " + in_sc ;// eslint-disable-line
    }else if (in_sc != "" && AccCardOption == "account" && (brand == 'ubn')) {
        sortCodeConf.textContent = "Sort code - "+ in_sc ;
    }else{
        sortCodeConf.textContent = '';
    }

    if (in_cardPan != "" && AccCardOption == "card") {
        creditCardConf.textContent = "Card account number - " + " " + in_cardPan ;// eslint-disable-line

    }else if(brand != 'ubn'){
        creditCardConf.textContent = '';
    }

    if ((strCreditCardNo != "") && (resCheck == "Yes") && in_cardPan != "" && AccCardOption == "card") {
        priCardNumConf.textContent = "First 6 and last 4 digits of Card number - " + " " + strCreditCardNo ;// eslint-disable-line

    }
    else if(brand != 'ubn'){
        priCardNumConf.textContent = '';
    }

    if (surname != "" && resCheck == 'Yes') {
        surNameConf.textContent = "Surname - " + " " + surname ;// eslint-disable-line
    }else{
        surNameConf.textContent="";
    }

    if (postCode != "" && resCheck == 'Yes') {
        postCodeConf.textContent = "Postal Code - " + " " + postCode ;// eslint-disable-line
    }else{
        postCodeConf.textContent="";
    }

    if (dob != "" && resCheck == 'Yes') {
        dateOfBirthConf.textContent = "Date of Birth - " + " " + dob ;// eslint-disable-line
    }else{
        dateOfBirthConf.textContent="";
    }

    //if single payment, only populate certain hidden fields
    if (paymentOption == "single") {
        amountConf.textContent = "£" + amount;
        amount1.value = amount;
        singleFields.style.visibility = "visible";
    }
    else //regular payments
    {

        //convert date to WP friendly format:
       // var dateSplit = paymentDate.split('-');
        var formattedDate = firpay_day + '-' + firpay_month + '-' + firpay_year;// eslint-disable-line

        startDate.value = firpay_year + '-' + firpay_month + '-' + firpay_day;;

        intervalUnit.value = in_freq;

        normalAmount.value = amount;

        var strFrequency = "";
        switch (in_freq) {
            case "1":
                strFrequency = "daily";
                break;
            case "2":
                strFrequency = "weekly";
                break;
            case "3":
                strFrequency = "monthly";
                break;
            case "4":
                strFrequency = "annually";
                break;
            default:
                break;

        }
        intervalUnitLbl.textContent = strFrequency;
        amount1Lbl.textContent = "£" + amount;
        startDateLbl.textContent = formattedDate;

        regularFields.style.visibility = "visible";

    }
}

